module.exports = __webpack_public_path__ + "static/assets/00fcfded5f78563d0d4b2e2c18377c5c.png";